let time = 497000; // 8:17 minutes
const hiddenDiv = document.getElementById("hidden");

hiddenDiv.style.display = "none";

function getCookie(name) {
    let cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
        let parts = cookies[i].split("=");
        if (parts[0] === name) {
            return parts[1];
        }
    }
    return null;
}

let visit = getCookie("first_visit");

if (!visit) {

document.cookie = "first_visit=1";
    setTimeout(function () {
        hiddenDiv.style.display = "block";
    }, time);

} else {

    // returning visit
    hiddenDiv.style.display = "block";

}